import React from "react";
import { component_tool } from "@/tool";
import { WizTableForm } from '@/containers/common';
import moment from "moment";
const organizationConfig = WizTableForm.Config.organization(this, { apiParams: { state: 1 } })
const positionConfig = WizTableForm.Config.position(this, { apiParams: { state: 1 } })
const formatterDateTime = (val) => {
  return val ? moment(val).format('YYYY.MM.DD HH.mm.ss') : '';
}
//配置项
const componentName = "orgRemoteAuthDetail";
let ref;
const _columns =() =>{
  return [
    {
      name: "id",
      formItem: {
        type: "hidden"
      }
    },
    {
      title: "姓名",
      name: "fullName",
      dataIndex: "fullName",
      tableItem: {
        width: 120,
      },
      formItem: {}
    },
    {
      title: "姓名",
      name: "fullNameSearch",
      dataIndex: "fullNameSearch",
      searchItem: {},
      formItem: {}
    },
    {
      title: "账号",
      name: "userName",
      dataIndex: "userName",
      tableItem: {
        width: 120,
      },
      formItem: {}
    },
    {
      title: "账号",
      name: "userNameSearch",
      dataIndex: "userNameSearch",
      searchItem: {},
      formItem: {}
    },
    {
      title: '手机号',
      name: 'mobile',
      tableItem: {
        width: 120,
      }
    },
    {
      title: "岗位",
      name: "positionIdList",
      searchItem: {
        diy: WizTableForm,
        ...positionConfig,
      }
    },

    {
      title: "任职",
      name: "jobName",
      tableItem: {
        width: 180,
      }
    },
    {
      title: "任职状态",
      name: "jobState",
      dict: [
        {code: 0, codeName: '离职'},
        {code: 1, codeName: '在职'},
      ],
      tableItem: {
        width: 100,
      },
    },
    {
      title: "是否参训",
      name: "attend",
      dict: [
        {code: 0, codeName: "否"},
        {code: 1, codeName: "是"}
      ],
      tableItem: {
        width: 100,
      },
      searchItem: {
        type: 'select'
      }
    },
    {
      title: "进入时间",
      name: "startTime",
      tableItem: {
        width: 100,
        render: (text, record) => {
          return formatterDateTime(text)
        }
      },
    },
    {
      title: "离开时间",
      name: "endTime",
      tableItem: {
        width: 100,
        render: (text, record) => {
          return formatterDateTime(text)
        }
      },
    },
    {
      title: "累计观看时长(分钟)",
      name: "durationMinute",
      tableItem: {
        width: 150,
        render: (text, record) => {
          return text ? text : ''
        }
      },
    },
    {
      title: "累计进入次数",
      name: "countNumber",
      tableItem: {
        width: 150,
      }
    },
  ];
}

const templateConfig = (date) => {
  const {onSelect} = date;
  let _onSelect = (key, rows) => {
    onSelect && onSelect(key, rows);
    ref && ref.getSelectRows(rows)
  };
  return {
    mainProps: {},
    content: {
      name: "WizTableList",
      params: {
        columns:_columns(),
        btnAccessCheck:false,
        searchBarProps: {
          buttonSort: ['export','syncLiveRecord'],
          buttons: [
            {
              key: 'export',
              custom: true,
              params: { icon: 'export', children: '导出参训记录', type:'primary'},
              customOnClick: {
                key: 'action',
                params: {
                  apiKey: "exportClassStudentInteractLive",
                  apiParams: {}
                },
                formatParams: (rows, record, filters, callback) => {
                  return { ...filters }
                }
              }
            },
            {
              key: "syncLiveRecord",
              custom: true,
              params: { icon: 'reload', children: '同步参训记录', type: 'reload'},
              customOnClick: {
                key: "action",
                params: {
                  apiKey: "syncLiveRecord",
                  apiParams: {}
                },
                formatParams: (rows, record, filters, callback) => {
                  return { ...filters }
                }
              }
            },
          ]
        },
        modalFormProps: {},
        dataTableProps: {
          rowKey: "id",
          isScroll: true,
          loading: false,
          onSelect: _onSelect
        },
        commonOperate: {
          update: false
        },
        rowOperateSort: [],
        rowOperateView: [ ]
      }
    }
  }
};



let reduxTemplateCofig = args => {
  const { id ,interactLiveId } = args;
  const apis = {
    list: {
      path: `${componentName}/orgRemoteAuthDetailInteractLiveListByPage`,
      payload: {
        key: `${componentName}@orgRemoteAuthDetailInteractLiveListByPage`,
        apiParams: { id}
      }
    },
    exportClassStudentInteractLive: {
      path: `${componentName}/orgRemoteAuthDetailInteractLiveExport`,
      payload: {
        key: `${componentName}@orgRemoteAuthDetailInteractLiveExport`,
        apiParams: { id}
      }
    },
    syncLiveRecord: {
      path: `liveRecord/syncLiveRecord`,
      payload: {
        key: `liveRecord@syncLiveRecord`,
        apiParams: {id : interactLiveId}
      }
    }
  };

  return {
    apis,
    componentName,
    initApiKeys: ["list"],
    keepInitApiParams: true,
    needLoading: false,
    ...args
  };
};

export { reduxTemplateCofig, templateConfig };
